<mat-card class="card-style modal-card px-6 py-6 pt-0">
  <mat-card-header class="modal-header flex justify-between items-center">
    <mat-card-title class="">Itinerários do item</mat-card-title>
    <button class="btn-icon" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-card-header>

  <div class="mt-6">
    <mat-card class="card-style note-card px-4 py-2 mt-4">
      <div class="flex justify-between items-center gap-4 mt-4">
        <div class="w-full">
          <b>Observação:</b><br />
          <div class="text-base font-semibold text-red-800 whitespace-pre-line">
            {{ item.observacao }}
          </div>
        </div>
      </div>
    </mat-card>

    @if (!loading) {
      <div class="flex flex-col gap-4 mt-4">
        @for (item of listItineraries; track item.id) {
          <mat-card
            class="card-style stop-card px-4 pb-6"
            [class.stop-origin]="item.trecho == 'O'"
            [class.stop-destination]="item.trecho == 'D'"
            [class.stop-waypoint]="item.trecho != 'O' && item.trecho != 'D'"
          >
            <h4 class="stop-title mb-1">
              {{
                item.trecho == 'O'
                  ? 'Origem'
                  : item.trecho == 'D'
                    ? 'Destino'
                    : 'Parada'
              }}
            </h4>
            @if (item.localParada != 'Origem' && item.localParada != 'Destino') {
              <div class="flex justify-between gap-2 mt-4">
                <div class="w-full">
                  <strong>Descrição:</strong> {{ item.localParada ?? '-' }}
                </div>
              </div>
            }
            <div class="flex justify-between gap-2 mt-4">
              <div class="w-6/12"><strong>Cidade:</strong> {{ item.cidade }}</div>
              <div class="w-6/12"><strong>Estado:</strong> {{ item.estado }}</div>
            </div>
            @if (
              item.cep ||
              item.logradouro ||
              item.numero ||
              item.bairro ||
              item.complemento ||
              item.latitude ||
              item.longitude ||
              item.horaParada ||
              item.tempoPermanencia ||
              item.atividades
            ) {
              <div class="flex justify-between gap-2 mt-4">
                <div class="w-2/12"><strong>Cep:</strong> {{ item.cep }}</div>
                <div class="w-8/12">
                  <strong>Logradouro:</strong> {{ item.logradouro }}
                </div>
                <div class="w-2/12">
                  <strong>Numero:</strong> {{ item.numero }}
                </div>
              </div>
              <div class="flex justify-between gap-2 mt-4">
                <div class="w-6/12">
                  <strong>Complemento:</strong> {{ item.complemento }}
                </div>
                <div class="w-3/12">
                  <strong>Latitude:</strong> {{ item.latitude }}
                </div>
                <div class="w-3/12">
                  <strong>Longitude:</strong> {{ item.longitude }}
                </div>
              </div>
              <div class="flex justify-between gap-2 mt-4">
                <div class="w-full"><strong>Bairro:</strong> {{ item.bairro }}</div>
              </div>
              <div class="flex justify-between gap-2 mt-4">
                <div class="w-6/12">
                  <strong>Hora da Parada:</strong> {{ item.horaParada }}
                </div>
                <div class="w-6/12">
                  <strong>Tempo de Permanência:</strong>
                  {{ item.tempoPermanencia }}
                </div>
              </div>
              <div class="flex justify-between gap-2 mt-4">
                <div class="w-full">
                  <strong>Atividades:</strong> {{ item.atividades }}
                </div>
              </div>
            }
          </mat-card>
        } @empty {
          <h3 class="text-center mt-4">Sem itinerários cadastrados.</h3>
        }
      </div>
    } @else {
      <div class="mt-4">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </div>
    }
  </div>
</mat-card>
